(function() {
	'use strict';
	angular.module('FYN').controller('PrivacyPolicyController', function() {

	})
})();